import {Map} from 'immutable';
import TextHighlightQuestionV2 from './V2/TextHighlightQuestion.react';
import TextHighlightExplanation from './V2/TextHighlightExplanation.react';
import TextHighlightResponseStats from './V2/TextHighlightExplanationResponseStats.react';
import TextHighlightEditor from './TextHighlightEditor.react';

export const TextHighlightQuestionType = Map({
  type: 'text-highlight',
  label: 'Text Highlight',
  questionRenderer: TextHighlightQuestionV2,
  explanationRenderer: TextHighlightExplanation,
  responseStatsRenderer: TextHighlightResponseStats,
  editor: TextHighlightEditor,
  isHidden: false
});
